  @if (!isFragmentationCollapsed) {
    <div class="body-content">
      <app-scrollable class="fragmentation-scroll">
        <div class="fragmentation-layout">

          <!-- Left: Filter Panel -->
          <div class="filter-panel">

            <!-- Interval Section -->
            <div class="filter-section">
              <div class="filter-section-header">{{'GLOBAL.INTERVAL' | translate}}</div>
              <div class="filter-section-body">
                <div class="min-max-row">
                  <div class="text-field-center">
                    <label class="field-label">{{'GLOBAL.MIN' | translate}}</label>
                    <app-input
                      type="number"
                      suffix="mm"
                      [ngModel]="intervalMin"
                      (ngModelChange)="onIntervalMinChange($event)">
                    </app-input>
                  </div>
                  <div class="text-field-center">
                    <label class="field-label">{{'GLOBAL.MAX' | translate}}</label>
                    <app-input
                      type="number"
                      suffix="mm"
                      [ngModel]="intervalMax"
                      (ngModelChange)="onIntervalMaxChange($event)">
                    </app-input>
                  </div>
                </div>
                <div class="filter-result">
                  {{intervalPercentage | number:'1.0-2'}} %
                </div>
              </div>
            </div>

            <!-- Diameter Section -->
            <div class="filter-section">
              <div class="filter-section-header">{{'GLOBAL.DIAMETER_SIZE' | translate}}</div>
              <div class="filter-section-body">
                <app-input
                  type="number"
                  suffix="%"
                  [ngModel]="diameterPercent"
                  (ngModelChange)="onDiameterPercentChange($event)">
                </app-input>
                <div class="filter-result">
                  {{diameterResult}} mm
                </div>
              </div>
            </div>

            <div class="filter-section-body">
              <!-- Data Table -->
              <app-data-table
                class="fragmentation-data-table"
                [data]="tableData"
                [columns]="tableColumns"
                [equalColumns]="true">
                <ng-template tableCell="percent" let-row>
                  {{row.percent}}%
                </ng-template>
                <ng-template tableCell="mm" let-row>
                  {{row.mm}}mm
                </ng-template>
              </app-data-table>
            </div>
            

          </div>

          <!-- Right: Graph + Image -->
          <div class="graph-panel">
            <!-- Toggle switches -->
            <div class="chart-toggle">
              <app-toggle
                [label]="'GLOBAL.FRAGMENTATION_DISTRIBUTION' | translate"
                [checked]="showDistribution"
                color= "mint"
                (changed)="onShowDistributionChange($event)">
              </app-toggle>
              <app-toggle
                [label]="'GLOBAL.FRAGMENTATION_CUMULATIVE_PERCENTAGE' | translate"
                [checked]="showCumulative"
                color= "mint"
                (changed)="onShowCumulativeChange($event)">
              </app-toggle>
            </div>
            <!-- Chart -->
            <div class="chart-wrapper">
              <canvas id="fragChart"></canvas>
            </div>
            <!-- Image -->
            <div class="image-container">
              @if (imagePath) {
                <img
                  [src]="imagePath"
                  alt="Muckpile Image"
                  class="fragmentation-image"
                  (click)="openImageModal()" />
              }
              @if (!imagePath) {
                <div class="image-placeholder">
                  <i class="fas fa-image"></i>
                  <span>{{'GLOBAL.NO_IMAGE' | translate}}</span>
                </div>
              }
            </div>
          </div>

        </div>
      </app-scrollable>
    </div>
  }
